export function checkWxSDKReady(callback) {
  if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
    callback();
  } else if (document.addEventListener) {
    document.addEventListener('WeixinJSBridgeReady', callback, false);
  } else if (document.attachEvent) {
    document.attachEvent('WeixinJSBridgeReady', callback);
    document.attachEvent('onWeixinJSBridgeReady', callback);
  }
}

/**
 * 屏蔽分享
 */
export function closeWindow() {
  checkWxSDKReady(() => {
    WeixinJSBridge.invoke('closeWindow');
  });
}
